import { render, staticRenderFns } from "./MessageDetailView.vue?vue&type=template&id=71fc44ce"
import script from "./MessageDetailView.vue?vue&type=script&lang=js"
export * from "./MessageDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports